/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2020 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import type Bookshelf from '../../common/models/Bookshelf';

export default function (bookshelf: Bookshelf | null | undefined): boolean {
	const owner = bookshelf?.user();
	const ownerId = owner ? owner.id() : undefined;
	const sessionUserId = app.session.user?.id();

	// Guard both ids: `undefined === undefined` would report every bookshelf as the viewer's own.
	if (ownerId === undefined || sessionUserId === undefined) {
		return false;
	}

	return ownerId === sessionUserId;
}
